import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("gcl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function wsUrl(token) {
  const base = BACKEND_URL.replace(/^https/, "wss").replace(/^http/, "ws");
  return `${base}/api/ws?token=${token}`;
}

export const api = {
  // auth
  login: (email, password) => client.post("/auth/login", { email, password }),
  register: (payload) => client.post("/auth/register", payload),
  googleSession: (sessionId) => client.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } }),
  me: () => client.get("/auth/me"),
  config: () => client.get("/config"),
  logout: () => client.post("/auth/logout"),
  confirmAge: () => client.post("/auth/confirm-age"),
  // experts
  listExperts: (params) => client.get("/experts", { params }),
  getExpert: (id) => client.get(`/experts/${id}`),
  applyExpert: (payload) => client.post("/experts/apply", payload),
  myExpertProfile: () => client.get("/experts/me"),
  updateExpertProfile: (payload) => client.put("/experts/me", payload),
  setPresence: (state) => client.post("/experts/me/presence", { state }),
  myEarnings: () => client.get("/experts/me/earnings"),
  // wallet
  wallet: () => client.get("/wallet"),
  ledger: () => client.get("/wallet/ledger"),
  creditPacks: () => client.get("/credit-packs"),
  checkout: (lookup_key) => client.post("/payments/checkout", { lookup_key, origin_url: window.location.origin }),
  paymentStatus: (sid) => client.get(`/payments/status/${sid}`),
  requestPayout: (amount_credits) => client.post("/payouts", { amount_credits }),
  // bookings / agenda
  addSlot: (datetime) => client.post("/experts/me/schedule", { datetime }),
  removeSlot: (slotId) => client.delete(`/experts/me/schedule/${slotId}`),
  expertSlots: (profileId) => client.get(`/experts/${profileId}/slots`),
  book: (profile_id, slot_id) => client.post("/bookings", { profile_id, slot_id }),
  myBookings: () => client.get("/bookings"),
  cancelBooking: (id) => client.post(`/bookings/${id}/cancel`),
  // rgpd account
  exportData: () => client.get("/account/export"),
  deleteAccount: () => client.delete("/account"),
  // consultations
  startConsultation: (profile_id) => client.post("/consultations", { profile_id }),
  listConsultations: () => client.get("/consultations"),
  getConsultation: (id) => client.get(`/consultations/${id}`),
  getMessages: (id) => client.get(`/consultations/${id}/messages`),
  acceptConsultation: (id) => client.post(`/consultations/${id}/accept`),
  refuseConsultation: (id) => client.post(`/consultations/${id}/refuse`),
  cancelConsultation: (id) => client.post(`/consultations/${id}/cancel`),
  endConsultation: (id) => client.post(`/consultations/${id}/end`),
  // reviews
  createReview: (payload) => client.post("/reviews", payload),
  // favorites / reports / support
  favorites: () => client.get("/favorites"),
  addFavorite: (expert_id) => client.post("/favorites", { expert_id }),
  removeFavorite: (expert_id) => client.delete(`/favorites/${expert_id}`),
  report: (payload) => client.post("/reports", payload),
  dispute: (payload) => client.post("/disputes", payload),
  support: (payload) => client.post("/support", payload),
  mySupport: () => client.get("/support"),
  // admin
  adminExperts: (status) => client.get("/admin/experts", { params: { status } }),
  adminApprove: (id) => client.post(`/admin/experts/${id}/approve`),
  adminReject: (id) => client.post(`/admin/experts/${id}/reject`),
  adminStats: () => client.get("/admin/stats"),
  adminConsultations: () => client.get("/admin/consultations"),
  adminPayments: () => client.get("/admin/payments"),
  adminReports: () => client.get("/admin/reports"),
  adminResolveReport: (id, resolution) => client.post(`/admin/reports/${id}/resolve`, { resolution }),
  adminPayouts: () => client.get("/admin/payouts"),
  adminProcessPayout: (id, action) => client.post(`/admin/payouts/${id}/${action}`),
  adminRefund: (payload) => client.post("/admin/refund", payload),
  adminSettings: () => client.get("/admin/settings"),
  adminUpdateSettings: (payload) => client.put("/admin/settings", payload),
  adminAuditLogs: () => client.get("/admin/audit-logs"),
  adminFounding: () => client.get("/admin/founding"),
  adminSetFounding: (id, action) => client.post(`/admin/experts/${id}/founding/${action}`),
};

export default client;
